<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}成员</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">成员基础信息</span>
          </div>
          <div class="card-content" style="width:320px">
            <el-form-item label="工号" prop="no">
              <el-input v-model="form.no" placeholder="请填写工号"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="请填写姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="idcard">
              <el-input v-model="form.idcard" placeholder="请填写身份证号"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="phone">
              <el-input v-model="form.phone" placeholder="请填写联系方式"></el-input>
            </el-form-item>
            <el-form-item label="系统权限" prop="phone">
              <el-select v-model="form.systemPower" placeholder="请选择" clearable @change="$forceUpdate()" >
                <el-option label="耗材" :value="0"></el-option>
                <el-option label="药品" :value="1"></el-option>
                <el-option label="全部" :value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="form.sex">
                <el-radio :label="0">男</el-radio>
                <el-radio :label="1">女</el-radio>
              </el-radio-group>
              <!-- <el-input v-model="form.sex"></el-input> -->
              <!-- <el-switch v-model="form.sex" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0" active-text="男" inactive-text="女">
            </el-switch> -->
            </el-form-item>
          </div>
        </div>

        <div class="edit-card" style="margin-top:10px">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">成员详细信息</span>
          </div>
          <div class="card-content">
            <el-form-item label="所属科室" prop="deptId">

              <!-- <div class="select_multiple_value" v-preventReClick @click="showDeptCheckDialog">
                <template v-if="deptChecked && deptChecked.length > 0">
                  <template v-for="item in deptChecked">
                    <div :key="item.id" class="value">
                      <span>{{ item.no + " " + item.name + " " }}
                        <i class="el-icon-close" v-preventReClick @click="removeDeptItem(item, $event)" />
                      </span>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <span style="color: #C8C9CC;">请选择所属科室</span>
                </template>
                <div style="clear:both"></div>
              </div> -->


              <div class="select_multiple_value" v-if="system_setting.IsUseWard" v-preventReClick @click="showDeptTreeDialog">
                <template v-for="item in deptTreeData">
                  <div :key="item.idGroup" class="value">
                    <span>{{ item.deptName + " " + (item.wardName?item.wardName:'' )+ " " }}
                      <i class="el-icon-close" style="cursor: pointer" v-preventReClick @click="removeItem1(item, $event)" />
                    </span>
                  </div>
                </template>
                <div style="clear: both"></div>
              </div>

              <div class="select_multiple_value" v-else v-preventReClick @click="showDeptCheckDialog">
                <template v-for="item in deptChecked">
                  <div :key="item.id" class="value">
                    <span>{{ item.no + " " + item.name + " " }}
                      <i class="el-icon-close" style="cursor: pointer" v-preventReClick @click="removeDeptItem(item, $event)" />
                    </span>
                  </div>
                </template>
                <div style="clear: both"></div>
              </div>
            </el-form-item>
            <el-form-item label="关联库房" prop="warehouseId">
              <div class="select_multiple_value" v-preventReClick @click="showWarehouseCheckDialog">
                <template v-if="warehouseChecked && warehouseChecked.length > 0">
                  <template v-for="item in warehouseChecked">
                    <div :key="item.id" class="value">
                      <span>{{ item.no + " " + item.name + " " }}
                        <i class="el-icon-close" style="cursor: pointer;" v-preventReClick @click="removeWarehouseItem(item, $event)" />
                      </span>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <span style="color: #C8C9CC;">请选择关联库房</span>
                </template>
                <div style="clear:both"></div>
              </div>
            </el-form-item>
            <el-form-item label="打印设置" prop="printSettingId">
              <el-select v-model="form.printSettingId" placeholder="请选择" filterable :filter-method="getPrintSettings" clearable style="width:290px">
                <el-option v-for="item in printSettings" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所属角色" prop="roleInfos">
              <div class="role-group">
                <div class="role" :class="getType(index)" v-for="(item, index) in form.roleInfos" :key="index">
                  {{ item.name }}
                </div>
              </div>
              <!-- <span>{{
                form.roleInfos && form.roleInfos.length > 0
                  ? form.roleInfos.map((e) => e.name).join("; ")
                  : ""
              }}</span> -->
            </el-form-item>
          </div>
        </div>
        <el-form-item label="启用状态">
          <el-switch v-model="form.state" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
          </el-switch>
          <span v-if="form.state">已启用</span>
          <span v-else>已禁用</span>
        </el-form-item>
      </el-form>


      <MyTableTree v-if="showDeptTreeDialogBox" :show="showDeptTreeDialogBox" :data="deptTreeList1" @getData="getDeptTreeDatas" :oldData="deptTreeData" @closeEvt="deptDeptTreeDialogClose" @filterMethod="GetDeptTreeData" />


      <my-tree :show="showDeptCheckBox" @close="deptCheckDialogClose" @getData="getDeptDatas" :leftData="deptTreeList" :oldData="deptChecked" @filterMethod="getDeptTreeList"></my-tree>
      <my-checkbox :show="showWarehouseCheckBox" @close="warehouseCheckDialogClose" @getData="getWarehouseDatas" :data="STATIC_Warehouses" :oldDatas="warehouseChecked" @filterMethod="getWarehouses"></my-checkbox>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
      <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import { GetUserById, SaveUser, GetDeptTreeList, GetPrintSettings,GetDeptAndWards,SaveUserEncrypt,GetWarehouses } from "@/api";
import MyTree from "@/components/my-tree";
import MyCheckbox from "@/components/my-checkbox";
import MyTableTree from "@/components/my-table-tree";
export default {
  name: "userEdit",
  mixins: [GetDataMixin],
  components: {
    MyTree,
    MyCheckbox,
    MyTableTree
  },
  data () {
    return {
      form: {
        
      },
      deptTreeList: [],
      deptChecked: [],
    
      warehouseChecked: [],
      showDeptCheckBox: false,
      showWarehouseCheckBox: false,
      rules: {
        no: [{ required: true, message: "请输入编码", trigger: "blur" }],
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        deptId: [
          { required: true, message: "请选择所属科室", trigger: "blur" },
        ],
      },
      printSettings: [],
      showDeptTreeDialogBox: false,
      deptTreeData:[],
      deptTreeData1: [],
    };
  },
  props: {
    // title: {
    //   type: String,
    //   default () {
    //     return ''
    //   }
    // }
  },
  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getDeptTreeList("");
    this.getWarehouses("");
    this.getPrintSettings('')
    this.GetDeptTreeData("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.title = "新建";
      this.resetForm();
      this.form.systemPower = 0
    },
    // 编辑
    handleUpdate (id) {
      GetUserById({ id }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
        if(this.form.systemPower == ''||this.form.systemPower== null){
          this.form.systemPower = 0
        }

        if (this.system_setting.IsUseWard) {
          this.deptTreeData = this.form.deptAndWardInfos
          // this.form.deptIds = this.form.deptAndWardIds
        } else {
          this.deptChecked = this.form.deptInfos;
        }

        this.warehouseChecked = this.form.warehouseInfos;
        // this.form.state = Boolean(this.form.state);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }

        if (!this.form.deptId) {
          this.$my_message(`请选择所属科室`, "warning");
          return;
        }
        let encyptBody = this.encryptCBC(JSON.stringify(this.form))
        
        SaveUserEncrypt({encyptBody}).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        sex: 0,
        password: '12345',
        state: 1,
        printSettingId: '',
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑部门
    cancel () {
      // this.open = false;
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
  
    showDeptCheckDialog () {
      if (!this.deptChecked) {
        this.deptChecked = [];
      }
      this.showDeptCheckBox = true;
    },

    showDeptTreeDialog () {
      this.showDeptTreeDialogBox = true;
      this.GetDeptTreeData("");
    },
    deptCheckDialogClose () {
      this.showDeptCheckBox = false;
    },
    deptDeptTreeDialogClose () {
      this.showDeptTreeDialogBox = false;
    },

    GetDeptTreeData (val) {
      GetDeptAndWards({
        keyWord: val
      }).then((res) => {
        this.deptTreeList1 = res.returnData;
        this.$forceUpdate();
      });
    },
    getDeptTreeDatas (data) {
      this.showDeptTreeDialogBox = false
      this.deptTreeData = data;
      this.form.deptIds = this.deptTreeData ? Array.from(new Set(this.deptTreeData.map((i) => i.deptId))).join(";") : ''
      this.form.wardIds = this.deptTreeData ? Array.from(new Set(this.deptTreeData.map((i) => i.wardId))).join(";") : ''
      this.form.deptAndWardIds = this.deptTreeData ? Array.from(new Set(this.deptTreeData.map((i) => i.idGroup))).join(";") : ''
      this.form.deptId = this.deptTreeData ? this.deptTreeData[0].deptId : "";
      // this.form.deptIds
    },

    getDeptDatas (datas) {
      this.deptChecked = datas;
      console.log(datas);
      
      this.form.deptIds = this.deptChecked
        ? this.deptChecked.map((i) => i.id).join(";")
        : "";
      this.form.deptId = this.deptChecked ? this.deptChecked[0].id : "";
      // this.form.deptNames = this.deptChecked ? this.deptChecked.map(i => i.no + ' ' + i.name) : []
    },
    removeItem1 (item, e) {
      console.log(item);
      
      this.deptTreeData = this.deptTreeData.filter((i) => i.idGroup != item.idGroup);
      this.form.deptIds = this.deptTreeData ?
        this.deptTreeData.map((i) => i.deptId).join(";") :
        "";
      this.form.deptAndWardIds = this.deptTreeData ?
        this.deptTreeData.map((i) => i.idGroup).join(";") :
        "";
      
      e.stopPropagation();
    },
    removeDeptItem (item, e) {
      this.deptChecked = this.deptChecked.filter((i) => i.id != item.id);
      this.form.deptIds = this.deptChecked
        ? this.deptChecked.map((i) => i.id).join(";")
        : "";
      this.form.deptId =
        this.deptChecked && this.deptChecked.length > 0
          ? this.deptChecked[0].id
          : "";

      e.stopPropagation();
    },
    showWarehouseCheckDialog () {
      if (!this.warehouseChecked) {
        this.warehouseChecked = [];
      }
      this.showWarehouseCheckBox = true;
    },
    warehouseCheckDialogClose () {
      this.showWarehouseCheckBox = false;
    },
    removeWarehouseItem (item, e) {
      this.warehouseChecked = this.warehouseChecked.filter(
        (i) => i.id != item.id
      );
      this.form.warehouseIds = this.warehouseChecked
        ? this.warehouseChecked.map((i) => i.id).join(";")
        : "";

      e.stopPropagation();
    },
    getWarehouseDatas (datas) {
      this.warehouseChecked = datas;
      this.form.warehouseIds = this.warehouseChecked
        ? this.warehouseChecked.map((i) => i.id).join(";")
        : "";
    },
    getDeptTreeList (val) {
      let data = {
        keyWord: val,
        pageIndex: 1,
        pageSize: 100,
      }
      GetDeptTreeList(data).then((res) => {
        this.deptTreeList = res.returnData;
      });
    },
    getPrintSettings (val) {
      GetPrintSettings({ pageIndex: 1, pageSize: 100, keyWord: val })
        .then(res => {
          this.printSettings = res.returnData.data
        })
    },

    getType (index) {
      let num = index % 5;
      switch (num) {
        case 0:
          return "default";
        case 1:
          return "success";
        case 2:
          return "warning";
        case 3:
          return "enable";
        case 4:
          return "danger";
      }
    },


    getWarehouses (keyWord) {
      return new Promise((resolve, reject) => {
        let query = { ...this.defaultAllQueryParams };
        query.keyWord = keyWord;
        query.state = 1;
        query.sourceType = 0
        GetWarehouses(query).then((response) => {
          if (response && response.returnData) {
            this.STATIC_Warehouses = response.returnData.data;
            resolve(response.returnData.data);
          } else {
            reject(response);
          }
        });
      });
    },

  },
};
</script>

<style lang="scss" scoped></style>
